import React from 'react';
import { ColorContext } from '../../../interfaces/App';
import StyledButton from './StyledButton';

interface ButtonProps {
  'aria-label'?: string;
  children: React.ReactNode; // Button content
  color?: ColorContext;
  component?: React.ElementType;
  disabled?: boolean; // Button disabled state
  height?: string;
  onClick?: () => void; // Click handler
  padding?: string;
  size?: 'small' | 'medium' | 'large'; // MUI Button size options
  tabIndex?: number;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'text' | 'outlined' | 'contained';
  fullWidth?: boolean;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({
  children,
  color = 'primary',
  component,
  disabled = false,
  height,
  onClick,
  padding,
  size = 'medium',
  type = 'button',
  tabIndex,
  variant = 'contained',
  fullWidth = false,
  style,
  ...props
}): JSX.Element => {
  return (
    <StyledButton
      as={component}
      color={color}
      disabled={disabled}
      onClick={onClick}
      size={size}
      type={type}
      tabIndex={tabIndex}
      variant={variant}
      fullWidth={fullWidth}
      padding={padding}
      style={style}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
